<template>
   <div class="card-body" style="background-color: #f0f2f5">
     <div class="col-12 col-md-10 col-lg-11 col-xl-8 m-auto">
        <div class="container-fluid">
          <div
              v-for="job in jobList"
              :key="job.id"
              class="card mb-2 hover-card cursor-pointer position-relative"
              @click="navigateToDetailPage(job)"
          >
            <img
                class="company-logo"
                :src="job.company_logo"
                alt="Company Logo"
            />

            <div class="card-body">
              <h6 class="card-title text-primary">{{ job.title }}</h6>
              <p class="mb-1 fw-bold">{{ job.company_name }}</p>
              <p class="mb-1">
                <i class="fas fa-map-marker-alt me-1 text-danger"></i> {{ job.area_name }}
              </p>
              <div class="d-flex justify-content-between">
                <p v-if="job.experience_required_from">
                  <i class="fas fa-briefcase me-1 text-primary"></i>
                  {{ job.experience_required_from }} to {{ job.experience_required_to }} Years
                </p>
                <p v-else></p>
                <p>
                  <i class="fas fa-calendar-day text-success"></i> Deadline:
                  <strong>{{ job.application_deadline_format }}</strong>
                </p>
              </div>
            </div>
          </div>


          <div class="px-2  bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
          </div>
        </div>
     </div>
   </div>
</template>

<script setup>
import Pagination from '@/components/atom/Pagination'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import {inject, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";

const loading = ref(false)
const jobList = ref([])
const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const {
  fetchCareerListData
} = handleHrPayroll()
const params = ref({
  offset: 20,
});
const getQuery = () => {
  let query = '?offset=' + params.value.offset;
  if (route.query.page) query += '&page=' + route.query.page;
  query += '&publish_status=publish';
  return query;
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getJobList();
}

const getJobList = async () => {
  const query = getQuery();
  loading.value = true
  jobList.value = []

  await fetchCareerListData(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    jobList.value = res.data.data;
    setPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

function navigateToDetailPage(item) {
  let param = {
    jobPostSlug: item.slug,
  }
  let query = route.query;

  router.push({
    name:  'job-post-details',
    params: param,
    query: query
  })
}

onMounted(() => {
  Promise.all([
    getJobList(),
  ])
})
</script>

<style scoped>
  .card {
    border-left: 4px solid #7367f0;
  }
  .sidebar {
    background: linear-gradient(to bottom right, #2d2f33, #1f2227);
    border-radius: 12px;
    min-height: 100vh;
    color: #fff;
  }
  .hover-card {
    transition: all 0.35s ease;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    background-color: #fff;
    position: relative;
    overflow: hidden;
    z-index: 1;
  }

  .company-logo {
    position: absolute;
    top: 10px;
    right: 10px;
    height: 100px;
    width: 100px;
    padding: 5px;
    z-index: 10;
  }

  .hover-card::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(0,123,255,0.05), rgba(0,123,255,0.1));
    opacity: 0;
    transition: opacity 0.35s ease;
    z-index: -1;
  }

  .hover-card:hover {
    transform: scale(1.02);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
    border-color: #7367f0;
  }

  .hover-card:hover::before {
    opacity: 1;
  }

  .sidebar-btn {
    background-color: #343a40;
    border: none;
    color: #ccc;
    font-weight: 500;
    border-radius: 8px;
    width: 100%;
    text-align: left;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: all 0.2s ease-in-out;
  }

  .sidebar-btn:hover {
    background-color: #495057;
    color: #fff;
    transform: translateX(2px);
  }

  .btn-danger {
    border-radius: 8px;
  }
</style>
